var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShutter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.837 0-16-7.163-16-16s7.163-16 16-16zM16 2.5c-7.456 0-13.5 6.044-13.5 13.5s6.044 13.5 13.5 13.5c7.456 0 13.5-6.044 13.5-13.5s-6.044-13.5-13.5-13.5zM16 5c6.075 0 11 4.925 11 11s-4.925 11-11 11c-6.075 0-11-4.925-11-11s4.925-11 11-11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShutter);
export default __webpack_public_path__ + "static/media/shutter.45b23b6831d2ff015ecf01d70bd8ed1e.svg";
export { ForwardRef as ReactComponent };